import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FETCH_CHANNELS } from '../../../../redux/Channels';
import ChannelItem from '../ChannelItem/ChannelItem';
import './ChannelsList.scss';

class ChannelsList extends PureComponent {
  componentDidMount() {
    this.props.fetchChannels();
  }

  renderItems() {
    const { channels, activeChannels, } = this.props;
    if (!channels) {
 return null;
}
    return channels.map((channel) => {
      return <ChannelItem channel={channel} key={get(channel, 'uniq_name')} activeChannels={activeChannels} />;
    });
  }

  render() {
    return (
      <div className="channels-list">
        {this.renderItems()}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchChannels: () => dispatch(FETCH_CHANNELS()),
});

const mapStateToProps = (state) => {
  return {
    channels: get(state, ['channels', 'channels']),
  };
};

ChannelsList.defaultProps = {
  channels: null,
};

ChannelsList.propTypes = {
  fetchChannels: PropTypes.func.isRequired,
  activeChannels: PropTypes.arrayOf(PropTypes.number).isRequired,
  channels: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChannelsList);
